import { push } from 'connected-react-router';

import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';
import LocalStorageHelper from '../helpers/local_storage';

export function requestSignUpOtp({ email, lastName, firstName, resend=false }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SIGNUP_REQUEST_OTP_REQUEST,
			payload: {
				loadingRequestSubmit: true
			}
		});

		const response = await API.auth.requestSignUpOtp({
			email,
			first_name: firstName,
			last_name: lastName
		});
	
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SIGNUP_REQUEST_OTP_SUCCESS,
				payload: {
					loadingRequestSubmit: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.SIGNUP_REQUEST_OTP_ERROR,
			payload: {
				loadingRequestSubmit: false
			}
		});

		// Stop execution if it will only resend otp
		if (resend) {
			return;
		}

		// store email
		LocalStorageHelper.setSignUpUser({
			email,
			last_name: lastName,
			first_name: firstName
		});

		// Navigate to next page
		dispatch(push('/create/verify'));
	};
}

export function verifySignUpOtp({ email, otp }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SIGNUP_VERIFY_OTP_REQUEST,
			payload: {
				loadingVerifySubmit: true
			}
		});

		const tempUser = LocalStorageHelper.getSignUpUser();
		const body = {
			email,
			last_name: tempUser.last_name,
			first_name: tempUser.first_name,
			otp
		};
		const response = await API.auth.verifySignUpOtp(body);
	
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SIGNUP_VERIFY_OTP_SUCCESS,
				payload: {
					loadingVerifySubmit: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.SIGNUP_VERIFY_OTP_ERROR,
			payload: {
				loadingVerifySubmit: false
			}
		});

		const { auth, user } = response.data;

		// Remove email
		LocalStorageHelper.removeSignUpUser();

		// store response
		LocalStorageHelper.setUser(user);
		LocalStorageHelper.setToken(auth.token);

		// Navigate to next page
		dispatch(push('/application'));
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_SIGNUP_META });
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({ type: ActionTypes.RESET_SIGNUP_PAGE });
	};
}